import "babel-polyfill";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";
import "./libs/sticky-kit.js";
import "./libs/KBmodal";
import "./libs/slick";

import {binder, fwa} from "./libs/binder";
import { staticFunctions, constants, commonFunction, anotherCommonFunction, navFunction, myUnusedFunction } from "./modules/module";
import customSelect from "./modules/customSelect";
import { dropdowns } from "./modules/dropdowns";
import { setStickyElement } from "./modules/stickyElement";
import { partnersFilter } from "./modules/partners-filter";
import { headerMenuAction } from "./modules/header";
import { historySlider } from "./modules/history-slider";
import { upcomingBlock } from "./modules/upcoming-block";
import { eventSlider } from "./modules/event-slider";
import { accordion } from "./modules/accordion";
import { commentsSlider } from "./modules/commentsSlider";
import { inputFile } from "./modules/inputFile";
import { datepicker } from "./modules/datepicker";
import { documentsToggle } from "./modules/documentsToggleList";
import { heroSlider } from "./modules/heroSlider";
import { fabricators } from "./modules/fabricators";
import stickyShare from "./modules/stickyShare";
import { tabs } from "./modules/tabs";
import modalWindow from "./modules/modalWindow";
import { rmaForm } from "./modules/rma-form";
import { shareBlock } from "./modules/share-block";
import { videoList } from "./modules/video-list";
import { partnerPostSlider } from "./modules/partner-post-slider";
import { partnerSerch } from "./modules/partner-serch";
import { easyscroll } from "./modules/easyscroll";
import { partnerLinks } from "./modules/partner-links";
import { categoryBox } from "./modules/category-box";
import { listBlockPopups } from "./modules/list-block-popups";
import { togglePass } from "./modules/togglePass";
import { labelForm } from "./modules/labelForm";
import { newsletterModal } from "./modules/newsletterModal";
import { scrollToTop } from "./modules/scrollToTop";
import { goToAnchor } from "./modules/goToAnchor";
import { scrollToFilters } from "./modules/scrollToFilters";

binder({
    bounds: {
        "html": [constants, staticFunctions],
        "body": [commonFunction, anotherCommonFunction],
        ".header": [navFunction, headerMenuAction],
        "select": customSelect,
        ".has-dropdown": [dropdowns],
        ".sticky-element": [setStickyElement],
        ".products-listing, .partners-filter": partnersFilter,
        ".history-slider-block": historySlider,
        ".upcoming-block": upcomingBlock,
        ".comments-slider-wrap": commentsSlider,
        ".event-slider": eventSlider,
        ".accordion": accordion,
        "input[type='file']": inputFile,
        ".datepicker": datepicker,
        ".parameters": documentsToggle,
        ".hero-media": heroSlider,
        ".fabricators-slider": fabricators,
        ".tabs": tabs,
        "[data-modal]": modalWindow,
        ".rma-form-block": rmaForm,
        ".share-block": shareBlock,
        ".video-list": videoList,
        ".partner-post-slider": partnerPostSlider,
        ".partner-search": partnerSerch,
        ".easyscroll": easyscroll,
        ".partner-links-block": partnerLinks,
        ".category-box": categoryBox,
        ".sticky-parent": stickyShare,
        ".list-block-item-btn.download": listBlockPopups,
        ".login": togglePass,
        "form": labelForm,
        ".footer-form": newsletterModal,
        ".top-link": scrollToTop,
        ".anchor-nav-list": goToAnchor,
        ".blog-container, .filtering-list form, .posts-block": scrollToFilters,
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js